<script setup lang="ts"></script>

<template>
  <section>
    <header />
    <main>
      <router-view />
    </main>
  </section>
</template>
